var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { omitBy } from 'lodash';
import { classToPlain } from 'class-transformer';
import { Collection } from './Collection';
import { call } from '../../helpers';
var PageCollection = /** @class */ (function (_super) {
    __extends(PageCollection, _super);
    // Set T as type
    function PageCollection(type, filter, perPage, currentPage) {
        if (filter === void 0) { filter = {}; }
        if (perPage === void 0) { perPage = 20; }
        if (currentPage === void 0) { currentPage = 0; }
        var _this = _super.call(this, type) || this;
        _this.filter = {};
        _this.currentPage = null;
        _this.perPage = null;
        _this.total = 0;
        _this.querySearch = '';
        _this.orderBy = '';
        _this.asc = true;
        _this.filter = filter;
        _this.perPage = perPage;
        _this.currentPage = currentPage;
        return _this;
    }
    Object.defineProperty(PageCollection.prototype, "lastPage", {
        /**
         * gets the last page
         */
        get: function () {
            return Math.floor(Math.max(this.total - 1, 0) / (this.perPage || 1));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Serializes the response body of a call to the WebServer
     * @param promise Any call of VUE RESOURCE
     */
    PageCollection.prototype.call = function (promise) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, call(this, promise)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Lists and Paginates the collection according to the config
     */
    PageCollection.prototype.search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, querySearch, currentPage, perPage, orderBy, asc, filter, filterParams, params;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, querySearch = _a.querySearch, currentPage = _a.currentPage, perPage = _a.perPage, orderBy = _a.orderBy, asc = _a.asc, filter = _a.filter;
                        filterParams = omitBy(classToPlain(filter), function (item) { return item === null || item === ''; });
                        params = {
                            query: querySearch,
                            page: currentPage !== null ? currentPage : undefined,
                            limit: perPage || undefined,
                            orderBy: orderBy,
                            ascending: asc,
                        };
                        return [4 /*yield*/, this.query(__assign({}, params, filterParams))];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Changes the orderby
     */
    PageCollection.prototype.setOrderBy = function (column) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.orderBy === column) {
                            this.asc = !this.asc;
                        }
                        else {
                            this.asc = true;
                        }
                        this.orderBy = column;
                        return [4 /*yield*/, this.search()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Changes the current page
     * @param val
     */
    PageCollection.prototype.setCurrentPage = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (val > this.lastPage) {
                            this.currentPage = this.lastPage;
                        }
                        else if (val < 0) {
                            this.currentPage = 0;
                        }
                        else
                            this.currentPage = val;
                        return [4 /*yield*/, this.search()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Searches using query conditions
     */
    PageCollection.prototype.searchByQuery = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.querySearch || !this.querySearch.length || this.querySearch.length > 2)) return [3 /*break*/, 2];
                        this.currentPage = 0;
                        return [4 /*yield*/, this.search()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Moves to the previous page
     */
    PageCollection.prototype.prevPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currentPage !== null && this.currentPage > 0)) return [3 /*break*/, 2];
                        this.currentPage--;
                        return [4 /*yield*/, this.search()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Moves to the next page
     */
    PageCollection.prototype.nextPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currentPage !== null && this.currentPage < this.lastPage)) return [3 /*break*/, 2];
                        this.currentPage++;
                        return [4 /*yield*/, this.search()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return PageCollection;
}(Collection));
export { PageCollection };
//# sourceMappingURL=PageCollection.js.map